const enTranslation = {
  header: {
    day: 'Day',
    week: 'Week',
    month: 'Month',
    administrator: 'Administrator',
    available: 'Available',
    logout: 'Log out',
    changeBloodbank: 'Change bloodbank',
    changePassword: 'Change password',
    changePhone: 'Change phone',

    tooltip: {
      configuration: 'Configuration',
      week: 'Week',
      messages: 'Messages',
      donors: 'Donors',
      reports: 'Reports'
    }
  },

  auth: {
    username: 'Username',
    enterEmailOrUsername: 'Enter your email or username',
    password: 'Password',
    enterPassword: 'Enter your password',
    forgotPassword: 'Forgot password',
    login: 'Log in',
    enterCorrectUsername: 'Enter the correct username',
    enterCorrectPassword: 'Enter the correct password',
    enterEmailToRecover: 'Please enter email to recover your password',
    enterEmail: 'Enter your email',
    email: 'Email',
    emailNotExist: 'Email does not exist',
    recoverPassword: 'Recover password',
    createNewPassword: 'Create new password',
    changeBloodbank: 'Select other bloodbank',
    changePassword: 'Change password',
    currentPassword: 'Current password',
    enterCurrentPassword: 'Enter the current password',
    newPassword: 'New password',
    enterNewPassword: 'Enter a new password',
    incorrectPassword: 'The password is incorrect',
    invalidPasswordComplex: 'Must contain at least {{minLength}} characters, including {{requirements}}.',
    invalidPasswordSimple: 'Must contain at least {{minLength}} characters.',
    passwordRequirements: {
      lowercase: 'lowercase',
      uppercase: 'uppercase',
      digit: 'a digit',
      special: 'a special character'
    },
    identicalPassword: 'Passwords are identical',
    confirm: 'Confirm',
    code: 'Code',
    enterCodeToProceed: 'Please enter a code which we sent via a text message to your phone number',
    enterCode: 'Enter code',
    enterYourCode: 'Enter your code',
    invalidCode: 'Invalid code',
    signInRejected: 'Sign-in was rejected. Please try again — contact support if the problem persists.',
    codeWasResent: 'The code was resent to your phone number, please check a text message',
    phoneWasChanged: 'Your phone number is successfully changed',
    changePhoneNumber: 'Change phone number',
    newPhoneNumber: 'New phone number',
    enterPhoneNumber: 'Enter a phone number',
    invalidPhoneNumber: 'Invalid phone number',
    resentCode: 'If you haven’t received the code, please click',
    here: 'here',
    enterYourCountry: 'Enter your country',
    loginError: 'Wrong username or password',
    loginUnavailable: 'The service is unavailable right now. Please try again shortly.',
    firewallErrorTitle: 'Unable to connect to external services',
    firewallError: 'Please ask your IT department to verify that the following addresses are not blocked by a firewall:',
    expiredPasswordResetLinkModal: {
      header: 'Try resetting your password again',
      body: 'Your request to reset your password has expired or the link has already been used',
    }
  },

  configuration: {
    overwriteModal: {
      header: 'Overwrite Appointment',
      body: 'Original appointment will be lost. Are you sure you want overwrite appointment with new values',
      body2: 'Donor status will be set to pending. Do you want to continue?',
      applyButton: 'Yes'
    },
    resourceDeleteModal: {
      header: 'Delete resource',
      body1: 'You can not delete a resource with the existing timeslot on it!',
      body2: 'Are you sure you want to delete this resource?',
      delete: 'Delete',
    },
    resourceEditModal: {
      header: 'Edit resource',
      body: 'Choose new name for this resource (if empty the index will be used)',
      input: 'Resource name',
      edit: 'Edit',
    },
    deleteResource: 'Delete resource',
    editResource: 'Edit resource',
    template: 'Choose template',
    Plain: 'Plain',
    newResource: 'New resource',
    resourceLimit: 'Resources limit is reached',
    editTimeslot: 'Edit timeslot',
    deleteAppointment: 'Delete appointment',
    bookAppointment: 'Book appointment',
    cancelBooking: 'Cancel booking',
    deleteTimeslot: 'Delete timeslot',
    downtime: 'Downtime',
    settings: {
      header: 'Timeslot settings',
      appointmentDuration: 'Appointment duration',
      allBloodTypes: 'All blood types',
      selectBloodType: 'Please select blood type',
      from: 'From',
      to: 'To',
      startDate: 'Start date',
      startTime: 'Start time',
      endTime: 'End time',
      shouldBeBeforeEnd: 'Should occur before the End time',
      shouldBeAfterStart: 'Should occur after the Start time',
      shouldBeGraterThanDuration: 'Should not be less than the appointment duration',
      shouldBeLessThanTheEndTime: 'Start time should be less than end time',
      shouldNotBeLessThanDuration: 'Time range should not be less than the appointment duration',
      allDay: 'All day',
      recurring: 'Recurring',
      exceptions: 'Exceptions',
      add: 'Add',
      discard: 'Discard',
      edit: 'Edit',
      remove: 'Remove',
      change: 'Change',
      titer: {
        allVariants: 'All variants',
        low: 'Low',
        high: 'High',
        unknown: 'Unknown',
        title: 'Titer (anti -A og -B)',
      },
      discardModal: {
        header: 'Discard changes?',
        body: 'All changes will be lost. Are you sure you want to discard unsaved changes?',
      },
      conflictModal: {
        header: 'Timeslots conflict',
        body: 'The new timeslot conflicts with the existing timeslot on the resource {{resourceIndex}}. You can change settings or proceed with creating of the timeslot on any available resource.',
      },
      noResourcesModal: {
        header: 'No available resources',
        body: 'There are no available resources. Please change the timeslot settings.',
      },
      cancelAppointmentsModal: {
        header: 'Cancel appointments',
        body: 'Please cancel all upcoming appointments before the changes to the timeslot can be done.',
      },
      deleteTimeslotModal: {
        header: 'Delete timeslot',
        body1: 'The timeslot has upcoming reservations. They are kept as standalone appointments; the rest of the timeslot is removed. Are you sure you want to delete the timeslot?',
        body2: 'Are you sure you want to delete the timeslot?',
      },
      deleteAppointmentModal: {
        header: 'Delete appointment',
        body1: 'Are you sure you want to delete the appointment?',
        body2: 'You can not delete the last appointment!',
      },
      bookAppointmentModal: {
        header: 'Book appointment',
        id: 'ID-number',
        searchPlaceholder: 'Type donor id',
        noMatch: 'No match for',
        selectAppointmentTime: 'Select appointment time',
        appointmentType: 'Select appointment type',
        appointmentTypeSelect: 'Select an appointment type',
        nextAppointment: 'This user already has an appointment',
        statusNotMatch: 'User status does not match appointment',
        titerNotMatch: 'User titer does not match appointment',
        donorTypeNotMatch: 'Donor type does not match appointment',
        inQuarantine: 'User in quarantine',
        overlapReserved: 'The selected time slot overlaps with another booking.',
        overlapTitle: 'Cannot book appointment',
        forceBookTitle: 'Booking checks failed — proceed?',
        forceBookBody: 'We found the following issues; confirm whether you want to proceed.',
        forceBook: 'Force Booking',
        forceBookNotAllowed: 'This booking cannot be forced because one or more checks are not overridable.',
        forceBookCheckEarliestDate: 'Earliest allowed date is {{date}}.',
        forceBookCheckQuarantine: 'Donor is in quarantine until {{date}}.',
        forceBookCheckAboMismatch: 'ABO does not match appointment requirements.',
        forceBookCheckRhdMismatch: 'Rhesus (RhD) does not match appointment requirements.',
        forceBookCheckAboRhdMismatch: 'ABO and Rhesus (RhD) do not match appointment requirements.',
        bloodTypeMismatchError: "The donor does not meet the appointment's blood type requirements.",
        forceBookCheckNotEligible: 'Donor is not eligible for this appointment type.',
        forceBookCheckMissingEligibility: 'Donor eligibility data is missing for this appointment type.',
        forceBookCheckTimeslotRange: 'Appointment date is outside the timeslot range.',
        forceBookCheckAppointmentTypeMismatch: 'Selected type "{{selectedType}}" does not match the timeslot type "{{originalType}}". Original appointment will be overwritten.',
        forceBookCheckExistingAppointment: 'Donor already has a booking on {{date}} at {{time}}.',
        forceBookCheckUnknown: 'Unknown check failed: {{check}}.',
        forceBookOverridable: 'Overridable',
        forceBookNotOverridable: 'Not overridable',
        bookingEligibilityMissing: 'Booking eligibility data is missing. This donor cannot be booked for this appointment type.',
        eligibilityCheckFailed: 'Could not load which appointment types this donor is eligible for. Try again — booking is blocked until the check succeeds.',
        earliestDateWarning: 'Earliest bookable date is {{date}}.',
        cancel: 'Cancel',
      },
      cancelBookingModal: {
        header: 'Cancel booking?',
        body: 'Reserved booking will be lost. Are you sure you want to continue?',
        selectAppointmentTime: 'Select appointment time',
      },
      counter: {
        pending: 'Pending',
        reserved: 'Reserved',
        archived: 'Archived'
      },
      redDayWarning: 'Red day',
    },
    recurrence: {
      header: 'Recurrence settings',
      daily: 'Daily',
      occur: 'Occur',
      everyDay: 'Every weekday',
      every: 'Every',
      days: 'days',
      weekly: 'Weekly',
      weeks: 'week(s)',
      on: 'On',
      monthly: 'Monthly',
      months: 'month(s)',
      onDay: 'On day',
      onThe: 'On the',
      First: 'First',
      Second: 'Second',
      Third: 'Third',
      Fourth: 'Fourth',
      Last: 'Last',
      ends: 'Ends',
      by: 'By',
      after: 'After',
      occurrences: 'occurrences',
      noEndDate: 'No end date',
    },
    exceptions: {
      header: 'Exception settings',
      excludeDate: 'Exclude date',
      addException: 'Add exception',
      dates: 'Dates',
      clearAll: 'Clear all',
      excludeHours: 'Exclude hours',
      from: 'From',
      to: 'To',
      onThe: 'On the',
      nonworkingHours: 'Hours',
      datesAndHours: 'Dates and hours',
      excludeHoursOnDate: 'Exclude hours on date',
    },
  },

  dashboard: {
    tasks: 'TASKS',
    findDonor: 'Find donor',
    search: 'Search',
    available: 'Available',
    reserved: 'Reserved',
    didAttend: 'Did attend',
    didNotAttend: 'Did not attend',
    signups: 'Signups',
    attendance: 'Attendance',
  },

  donorDetails: {
    header: 'Donor details',
    idNumber: 'ID-number',
    lastDraw: 'Last appointment',
    noLastDraw: 'No last appointment',
    quarantine: 'Quarantine',
    quarantineExpires: 'Quarantine expires on',
    noQuarantineDate: 'No quarantine date',
    description: 'Description',
    nextAppointment: 'Next Appointment',
    donorContacts: 'Donor Contact Details',
    address: 'Address',
    postalCode: 'Postal code',
    city: 'City',
    email: 'Email',
    phone: 'Phone number',
    becs: 'Entry in BECS',
    appuser: 'APP-user',
    sms: 'SMS',
    donationSite : 'Donation site',
    moveDonor: {
      title: 'Move donor to {{site}}?',
      body: 'The donor disappears from the donor list of {{from}} and appears under {{to}}.',
      confirm: 'Move',
      activeBooking: 'The donor has an active appointment. Cancel the appointment before moving the donor.',
      featureDisabled: 'Switching donation site is not enabled for this health trust.',
    },
  },

  showUp: {
    header: 'Show-up',
    yes: 'Yes',
    no: 'No',
  },

  common: {
    selectValue: 'Select value',
    quarantineDue:'Quarantine due',
    nextAppointment: 'Next Appointment',
    confirm: 'Confirm',
    book: 'Book',
    cancel: 'Cancel',
    close: 'Close',
    clear: 'Clear',
    apply: 'Apply',
    save: 'Save',
    delete: 'Delete',
    proceed: 'Proceed',
    ok: 'Ok',
    all: 'All',
    cancelBooking: 'Cancel',
    bloodType: 'Blood type',
    donorType: {
      header: 'Donor type',
      full_blood: 'Full blood',
      apheresis: 'Apheresis',
    },
    titer: {
      low: 'Low',
      high: 'High',
      unknown: 'Unknown',
      title: 'Titer (anti -A og -B)',
    },
    appointmentType: {
      header: 'Appointment type',
      'New registration': 'New registration',
      'First time draw': 'First time draw',
      'N\'th time draw': 'N\'th time draw',
      'Erythrocytapheresis': 'Erythrocytapheresis',
      'Plateletpheresis': 'Plateletpheresis',
      'Plasmapheresis': 'Plasmapheresis',
      'Consultation': 'Consultation',
    },
    appUserStatus: {
      header: 'APP-user',
      yes: 'Yes',
      no: 'No',
    },
    eligibleFor: 'Eligible for',
    selfService: 'Self service',
    appointmentStatus: {
      header: 'Appointment',
      yes: 'Yes',
      no: 'No',
    },
    smsStatus: {
      header: 'SMS',
      true: 'Yes',
      false: 'No',
    },
    donorStatus: {
      header: 'Donor status',
      pending: 'Pending',
      new: 'New',
      approved: 'Approved',
      established: 'Established',
    },
    month: {
      January: 'January',
      February: 'February',
      March: 'March',
      April: 'April',
      May: 'May',
      June: 'June',
      July: 'July',
      August: 'August',
      September: 'September',
      October: 'October',
      November: 'November',
      December: 'December',
      Jan: 'Jan',
      Feb: 'Feb',
      Mar: 'Mar',
      Apr: 'Apr',
      Jun: 'Jun',
      Jul: 'Jul',
      Aug: 'Aug',
      Sep: 'Sep',
      Oct: 'Oct',
      Nov: 'Nov',
      Dec: 'Dec',
    },
    day: {
      Sunday: 'Sunday',
      Monday: 'Monday',
      Tuesday: 'Tuesday',
      Wednesday: 'Wednesday',
      Thursday: 'Thursday',
      Friday: 'Friday',
      Saturday: 'Saturday',
      Sun: 'Sun',
      Mon: 'Mon',
      Tue: 'Tue',
      Wed: 'Wed',
      Thu: 'Thu',
      Fri: 'Fri',
      Sat: 'Sat',
      Su: 'Su',
      Mo: 'Mo',
      Tu: 'Tu',
      We: 'We',
      Th: 'Th',
      Fr: 'Fr',
      Sa: 'Sa',
    }
  },

  pagination: {
    previous: 'Previous',
    next: 'Next',
    rows_amount: 'Rows amount',
    of: 'of',
    all: 'all',
  },

  table: {
    no_data: 'There is no data',
    no_match: 'There is no match for',
    try_another: 'Please try another search',
    name: 'Name',
    ID_number: 'ID number',
    last_draw: 'Last appointment',
    blood_type: 'Blood type',
    titer: 'Titer',
    donor_status: 'Donor status',
    donor_type: 'Donor type',
    quarantine_due_date: 'Quarantine due date',
    app_user: 'APP-user',
    sms: 'SMS',
    next_appointment: 'Next appointment',

    id: 'ID',
    date: 'Date / Time',
    title: 'Title',
    message: 'Message',
    signature: 'Signature',
    candidate: 'Candidate',

    message_id: 'Message ID',
    receiver_id: 'Receiver ID',
    category: 'Category',

    msg_type: 'Type',
    msg_source: 'Source',
  },

  msgs: {
    index: 'Index',
    id: 'ID',
    date: 'Date / Time',
    title: 'Title',
    message: 'Message',
    authorized_user: 'Authorized user',
    messages_editor: 'Messages editor',
    send: 'Send',
    candidates_amount: 'Candidates amount',
    search: 'Search',
    admin: 'Admin',
    system_sent: 'Auto',
    system_scheduled: 'Scheduled',
    filterMatches: '{{count}} donors match',
    filter_settings: 'Filter settings',
    filter: 'Filter',
    message_id: 'Message ID',
    receiver_id: 'Receiver ID',
    queued: 'The message has been queued',
    status: {
      queued: 'Queued',
      processing: 'Sending',
      failed: 'Failed',
    },

    // PNR search: every message one donor received, all types
    donor: {
      truncated: 'Showing only the {{count}} most recent messages.',
      error: {
        donor_not_in_bloodbank: 'The donor does not belong to this blood bank',
        donor_not_found: 'No donor found',
        request_failed: 'Could not load the donor\'s messages',
      },
      type: {
        donor_ready: 'Ready to donate',
        donor_quarantine: 'Quarantine ends',
        donor_cancel: 'Cancelled appointment',
        donor_cancelled: 'Cancelled appointment',
        donor_upcoming_1w: 'Reminder (1 week)',
        donor_upcoming_1d: 'Reminder (1 day)',
        donor_upcomed: 'Appointment confirmation',
        donor_upcoming: 'Reminder',
        mismatch_cancelled: 'Cancelled (profile changed)',
        email_reminder: 'Email reminder',
        // legacy documents without a type: inferred from the text
        registration: 'Registration',
        // nothing matched
        unknown: 'Message',
      },
    },

    tooltip: {
      bloodbank: 'Bloodbank',
      blood_type: 'Blood type',
      titer: 'Titer',
      donor_status: 'Donor status',
      app_user: 'APP-user',
      sms: 'SMS',
    }
  },

  reports: {
    title: 'Reports',
    stage: {
      alpha: 'Alpha',
      beta: 'Beta',
    },
    alphaNote: 'Reports is an alpha feature. Content may change and numbers may differ from the blood bank\'s own system.',
    unavailable: {
      title: 'Not available',
      message: 'Reports is not enabled for your user.',
    },
    noAccess: 'You do not have access to reports for this blood bank.',
    noBloodbank: 'Select a blood bank to see reports.',
    period: {
      label: 'Period',
      from: 'From',
      to: 'To',
      preset: 'Last {{count}} months',
      invalid: 'Pick a period of 1–24 months where "from" is not after "to".',
    },
    export: 'Download CSV',
    loading: 'Loading numbers …',
    empty: 'No data for the period',
    emptyHint: 'Try a longer period, or choose another blood bank.',
    error: {
      title: 'Could not load the report',
      retry: 'Retry',
    },
    inProgress: 'in progress',
    inProgressNote: 'Months marked "in progress" are not closed and may still change.',
    updatedAt: 'Updated {{date}}',
    footer: 'The numbers cover bookings and donors registered in Blodgiver. Donation data (Hb, deferrals, volume) lives in the blood bank\'s own system.',
    sections: {
      attendance: 'Attendance',
      cancellations: 'Cancellations',
      capacity: 'Capacity',
      channel: 'Booking channel',
      donors: 'Donor base',
      messages: 'Messages',
      matrix: 'Appointment type × blood type',
      table: 'Monthly table',
    },
    summary: {
      title: 'Overview',
    },
    groups: {
      bookings: 'Bookings',
      donors: 'Donors and messages',
      details: 'Details',
    },
    chart: {
      perMonth: 'Per month',
      by: 'By {{dimension}}',
    },
    table: {
      total: 'Total',
    },
    kpi: {
      booked: 'Booked',
      attended: 'Attended',
      noShow: 'No-show',
      noShowRate: 'No-show rate',
      cancelled: 'Cancelled',
      slots: 'Slots',
      capacityBooked: 'Booked slots',
      free: 'Free slots',
      utilisation: 'Utilisation',
      donorsTotal: 'Donors',
      inQuarantine: 'In quarantine',
      withApp: 'With app',
      newRegistrations: 'New registrations',
      lapsed12m: 'No attendance in 12+ months',
      messagesCount: 'Sendouts',
      audienceSize: 'Recipients',
      smsCount: 'SMS',
      month: 'Month',
    },
    hints: {
      noShowRate: 'No-shows divided by attended + no-shows',
      donorsAsOf: 'The donor base as of the latest computation ({{month}}). New registrations are summed over the period.',
      bookedCancelled: 'Booked and cancelled count in the month the action was taken; attended and no-show in the month of the appointment.',
      rateWhenClosed: 'Shown once the month has closed',
    },
    notes: {
      cancellations: 'Cancellations per month, by who cancelled and how long before the appointment it happened.',
      capacity: 'How many of the available slots were booked, per month and per weekday and time of day.',
      channel: 'Where bookings come from: donors themselves in the app, or blood bank staff.',
      messages: 'Messages sent to donors per month: number of mailings, recipients and SMS.',
      table: 'All monthly figures in one table, with the period total at the bottom. Can be downloaded as CSV.',
    },
    breakdown: {
      label: 'Break down by',
      none: 'None',
      appointmentType: 'Appointment type',
      bloodType: 'Blood type',
      donorStatus: 'Donor status',
      titer: 'Titer',
      channel: 'Channel',
      perMonth: 'Show per month for',
      all: 'All',
      empty: 'No bookings to break down in the period',
    },
    channel: {
      donor: 'Donor (app)',
      staff: 'Staff',
      system: 'System',
      shareTitle: 'Share of bookings per channel',
    },
    leadTime: {
      title: 'Time from cancellation to the appointment',
      lt24h: 'Under 24 h',
      '24to72h': '24–72 h',
      gt72h: 'Over 72 h',
    },
    donorStatus: {
      new_registration: 'New registration',
      new: 'New',
      approved: 'Approved',
      established: 'Established',
      pending: 'Pending',
      ukjent: 'Unknown',
    },
    titer: {
      high: 'High',
      low: 'Low',
      ukjent: 'Unknown',
    },
    unknown: 'Unknown',
    weekdays: {
      1: 'Mon',
      2: 'Tue',
      3: 'Wed',
      4: 'Thu',
      5: 'Fri',
      6: 'Sat',
      7: 'Sun',
    },
    heatmap: {
      title: 'Utilisation per weekday and hour',
      hour: 'Hour',
      cell: '{{booked}} of {{slots}} slots booked',
      empty: 'No capacity data for the period',
      legendLow: 'Low',
      legendHigh: 'High',
    },
    donors: {
      byStatus: 'By status',
      byBloodType: 'By blood type',
    },
    matrix: {
      booked: 'booked',
      attended: 'attended',
      cellFormat: '{{booked}} / {{attended}}',
      legend: 'Booked / attended, summed over the period',
      empty: 'No bookings for the period',
      total: 'Total',
    },
  },

  // Must stay byte-identical to the legacy getRuleDescription output: this
  // is the text the backend stores as `ruleDescription`.
  recurrenceSummary: {
    everyDay: 'Every day',
    everyNDays: 'Every {{n}} days',
    everyWeek: 'Every week',
    everyNWeeks: 'Every {{n}} weeks',
    everyMonth: 'Every month',
    everyNMonths: 'Every {{n}} months',
    onWeekdays: 'on {{days}}',
    onMonthDay: 'on the {{day}}',
    onMonthWeekday: 'on the {{ordinal}} {{weekday}}',
    until: 'until {{date}}',
    times: 'for {{n}} times',
    weekday: {
      Sunday: 'Sunday',
      Monday: 'Monday',
      Tuesday: 'Tuesday',
      Wednesday: 'Wednesday',
      Thursday: 'Thursday',
      Friday: 'Friday',
      Saturday: 'Saturday',
    },
    weekdayDefinite: {
      Sunday: 'Sunday',
      Monday: 'Monday',
      Tuesday: 'Tuesday',
      Wednesday: 'Wednesday',
      Thursday: 'Thursday',
      Friday: 'Friday',
      Saturday: 'Saturday',
    },
    ordinal: {
      First: 'First',
      Second: 'Second',
      Third: 'Third',
      Fourth: 'Fourth',
      Last: 'Last',
    },
  },

  exceptionSummary: {
    hoursOnWeekdays: 'From {{from}} to {{to}} on {{days}}',
    hoursOnDate: 'From {{from}} to {{to}} on {{date}}',
    weekday: {
      Sun: 'Sun',
      Mon: 'Mon',
      Tue: 'Tue',
      Wed: 'Wed',
      Thu: 'Thu',
      Fri: 'Fri',
      Sat: 'Sat',
    },
  },

  errorBoundary: {
    title: 'Something went wrong',
    message: 'There was a problem loading this page. Please check your connection and try again.',
    retry: 'Retry',
  }
}

export default enTranslation;
